define("ember-cp-validations/utils/array", ["exports", "@ember/array"], function (_exports, _array) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.callable = callable;
  _exports.compact = void 0;
  _exports.flatten = flatten;
  _exports.uniq = void 0;
  const A = (0, _array.A)();
  function callable(method) {
    return function (collection) {
      return A[method].apply(collection, arguments);
    };
  }
  const uniq = _exports.uniq = callable('uniq');
  const compact = _exports.compact = callable('compact');
  function flatten() {
    let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let result = [];
    for (let i = 0, l = array.length; i < l; i++) {
      let item = array[i];
      if (Array.isArray(item)) {
        result = result.concat(flatten(item));
      } else {
        result.push(item);
      }
    }
    return result;
  }
});